module.exports = __webpack_public_path__ + "img/condo.6ca62006.svg";